export default "__VITE_ASSET__Co7a$VID__"